module.exports = __webpack_public_path__ + "img/illu-icon-46-chat.8c2659d0.svg";